export const FETCH_PACKAGE_STOCK_LOCATIONS_PENDING = "FETCH_PACKAGE_STOCK_LOCATIONS_PENDING";
export const FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED = "FETCH_PACKAGE_STOCK_LOCATIONS_REJECTED";
export const FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED = "FETCH_PACKAGE_STOCK_LOCATIONS_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/packageStockLocations.js